import { render, staticRenderFns } from "./authorize-payroll.vue?vue&type=template&id=1ba4b1dd"
import script from "./authorize-payroll.vue?vue&type=script&lang=js"
export * from "./authorize-payroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports